import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AtomicButton from '../button/AtomicButton';
import variables from "../../global/assets/_variables.scss";
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper';
import "./Dialog.scss";



export default function AlertDialog(props) {
    const { open,
        setOpen,
        onAgree,
        onDisagree,
        displayText,
        isLoading = false,
        showAgreeButton = true,
        showDisagreeButton = true,
        buttonAgreeLabel = "Okay",
        buttonDisagreeLabel = "Close",
        icon,
        iconWidth = "125px",
        children,
    } = props


    const buttonStyleProp = {
        //width: isMobile ? "150px" : "205px",
        width: 'auto',
        height: "35px",
        // padding: "6px",
        margin: '15px 5px 15px 5px',
        fontSize: "14px",
        lineHeight: "initial",
        backgroundColor: variables.activeFontOrange,
        // flexGrow: 1,
        // flexShrink: 1,
    }


    const handleClose = () => {
        if (setOpen) {
            setOpen(false);
        }
    };

    return (

        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="alert-dialog-wrapper"
        >

            {children && <div style={{
                padding: '30px',
                width: 'auto',
                //maxHeight: '1100px',
                overflowX: 'hidden',
            }}>

                {icon && <img style={{ width: iconWidth }} src={icon} alt=""></img>}
                {isLoading ? 'Loading ...' : <div style={{ margin: '10px', color: '#181436', fontSize: '16px', textAlign: 'center' }}>{displayText}</div>}

                {children}

                <div style={{ display: 'flex', flexDirection: 'row' }}>

                    {showDisagreeButton && <AtomicButton
                        label={buttonDisagreeLabel}
                        loading={isLoading}
                        style={{
                            ...buttonStyleProp, backgroundColor: 'white',
                            border: `2px solid ${variables.activeFontOrange}`, color: variables.activeFontOrange
                        }}
                        handleSubmit={onDisagree}
                    />}
                    {showAgreeButton &&
                        <AtomicButton
                            label={buttonAgreeLabel}
                            loading={isLoading}
                            style={buttonStyleProp}
                            handleSubmit={onAgree}
                        />}
                </div>

            </div>}


            {!children && <div style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '10px',
                width: isMobile ? "300px" : "auto",
                //maxHeight: '1000px',

            }}>
                {icon && <img style={{ width: iconWidth }} src={icon} alt=""></img>}
                {isLoading ? 'Loading ...' : <div style={{ margin: '10px', color: '#181436', fontSize: '16px', textAlign: 'center' }}>{displayText}</div>}

                <div style={{ display: 'flex', flexDirection: 'row' }}>

                    {showDisagreeButton && <AtomicButton
                        label={buttonDisagreeLabel}
                        loading={isLoading}
                        style={{
                            ...buttonStyleProp, backgroundColor: 'white',
                            border: `2px solid ${variables.activeFontOrange}`, color: variables.activeFontOrange
                        }}
                        handleSubmit={onDisagree}
                    />}
                    {showAgreeButton &&
                        <AtomicButton
                            label={buttonAgreeLabel}
                            loading={isLoading}
                            style={buttonStyleProp}
                            handleSubmit={onAgree}
                        />}
                </div>
            </div>}
        </Dialog>

    );
}
